import { Link } from "react-router-dom";

interface MapToolbarProps {
  totalArvores: number;
  filteredCount: number;
  loading: boolean;
  exporting: boolean;
  onExportGeoJSON: () => void;
  onCenterMap: () => void;
  onToggleLayers: () => void;
  layersOpen: boolean;
}

export default function MapToolbar({
  totalArvores,
  filteredCount,
  loading,
  exporting,
  onExportGeoJSON,
  onCenterMap,
  onToggleLayers,
  layersOpen,
}: MapToolbarProps) {
  return (
    <div className="bg-white border-b border-background-200/70 px-6 py-3">
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-foreground-500 mb-2">
        <Link to="/" className="hover:text-accent-500 transition-colors whitespace-nowrap">
          Dashboard
        </Link>
        <i className="ri-arrow-right-s-line text-xs" aria-hidden="true"></i>
        <span className="text-foreground-800 font-medium whitespace-nowrap">Mapa Arbóreo</span>
      </nav>

      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-lg font-bold text-foreground-900 font-heading">Mapa Arbóreo</h1>
          <p className="text-xs text-foreground-500 mt-0.5">
            Exemplares arbóreos cadastrados no CTA, sobre a área piloto e suas quadras.
          </p>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-btn whitespace-nowrap">
            {loading ? (
              "Carregando exemplares…"
            ) : (
              <>
                <strong className="text-foreground-800">{filteredCount}</strong> de {totalArvores} exemplares visíveis
              </>
            )}
          </span>

          <Link to="/cta/novo" className="btn-primary text-xs px-3 py-2 whitespace-nowrap" title="Cadastrar novo exemplar arbóreo">
            <i className="ri-add-line text-sm" aria-hidden="true"></i>
            <span>Novo exemplar</span>
          </Link>

          <button
            onClick={onExportGeoJSON}
            disabled={exporting}
            className="btn-outline text-xs px-3 py-2 whitespace-nowrap disabled:opacity-60"
            title="Baixar os exemplares cadastrados em GeoJSON"
          >
            <i className="ri-download-2-line text-sm" aria-hidden="true"></i>
            <span>{exporting ? "Exportando…" : "Exportar GeoJSON"}</span>
          </button>

          <button onClick={onCenterMap} className="btn-outline text-xs px-3 py-2 whitespace-nowrap" title="Enquadrar os exemplares visíveis">
            <i className="ri-focus-3-line text-sm" aria-hidden="true"></i>
            <span>Centralizar</span>
          </button>

          <button
            onClick={onToggleLayers}
            className={`text-xs px-3 py-2 rounded-btn border font-medium transition-colors duration-150 whitespace-nowrap ${
              layersOpen ? "bg-accent-100 text-accent-700 border-accent-300" : "btn-outline"
            }`}
            title="Gerenciar camadas"
          >
            <i className="ri-stack-line text-sm" aria-hidden="true"></i>
            <span>Camadas</span>
          </button>
        </div>
      </div>
    </div>
  );
}
